export class Address {
  country: string;
  webAddress: string;
  locationCategory: string;
  advertisingSpot: string;
  addressComponents: any;
  adrAddress: string;
  formattedAddress: string;
  name: string;
  photos: any;
  url: string;
  lat: number;
  lng: number;

  constructor(
    country?: string,
    webAddress?: string,
    locationCategory?: string,
    advertisingSpot?: string,
    addressComponents?: any,
    adrAddress?: string,
    formattedAddress?: string,
    name?: string,
    photos?: any,
    url?: string,
    lat?: number,
    lng?: number
  ) {
    this.country = country;
    this.webAddress = webAddress || null;
    this.locationCategory = locationCategory || null;
    this.advertisingSpot = advertisingSpot || null;
    this.addressComponents = addressComponents || [];
    this.formattedAddress = formattedAddress || null;
    this.adrAddress = adrAddress || null;
    this.name = name || null;
    this.adrAddress = adrAddress || null;
    this.photos = photos;
    this.url = url || null;
    this.lat = lat || null;
    this.lng = lng || null;
  }
}
